export default {
  methods: {
    refreshKey: function () {
      return (Math.random() + 1).toString(36).substring(7)
    }
  }
}
